module.exports = __webpack_public_path__ + "img/hjemmelavet-pasta.4adaac7f.jpg";